import React from "react";
import award from "./../imgs/award.png";
import talent from "./../../home/imgs/talent.png";
import techAward from './../../home/imgs/techAward.png';

// import Swiper core and required modules
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default function Awards() {
  return (
    <>
      <style>
        {`
          .swiper-pagination {
            margin-top: 3cm;
          }

          .swiper-pagination-bullet {
            background: #414040; 
            width: 8px;
            height: 8px;
            border-radius: 50%; 
            margin: 30px 5px; 
          }

          .swiper-pagination-bullet-active {
            background: #3A636C className="w-10";
          }
        `}
      </style>
      <div className="mb-20">
        <h1 className="text-3xl font-bold  my-8 text-customBlue  text-center">
          Our<span className="ms-2 text-[#3A636C]">Acheivements</span>
        </h1>
        <h4 className="mt-[-30px] text-center">We managed to acheive</h4>
      </div>
      <Swiper
        // install Swiper modules
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]} // Add Autoplay module here
        spaceBetween={50}
        slidesPerView={3}
        autoplay={{
          delay: 3000, // Set autoplay delay to 3 seconds
          disableOnInteraction: false, // Autoplay will not stop after user interaction
        }}
        pagination={{ clickable: true }}
        loop={true}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log("slide change")}
        className="h-72 my-8 "
      >
        <center>
          <SwiperSlide className="flex justify-center items-center shadow-xl">
            <div className="rounded-md shadow-lg p-8 flex justify-center items-center w-full h-full bg-cardFieldFocusbg">
              <img
                src={talent}
                alt="talentAwardgiventoGrandshoprwanda"
                className="object-contain w-full h-full"
              />

              <div className="w-10">
                <h1 className="font-semibold text-lg">African Talent Award</h1>
                <p className="font-mono">May, 2016</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="flex justify-center items-center shadow-xl">
            <div className="rounded-md shadow-lg p-8 flex justify-center items-center w-full h-full bg-cardFieldFocusbg">
              <img
                src={award}
                alt="AwardgiventoGrandshoprwanda"
                className="object-contain w-full h-full"
              />

              <div className="w-32 me-8">
                <h1 className="font-semibold text-lg">
                  Africa Illustrious Award
                </h1>
                <p className="font-mono">Mar, 2014</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="flex justify-center items-center shadow-xl">
            <div className="rounded-md shadow-lg p-8 flex justify-center items-center w-full h-full bg-cardFieldFocusbg">
              <img
                src={techAward}
                alt="AwardgiventoGrandshoprwanda"
                className="object-contain w-full h-full"
              />

              <div className="w-10">
                <h1 className="font-semibold text-lg">African Talent Award</h1>
                <p className="font-mono">May, 2016</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="flex justify-center items-center shadow-xl">
            <div className="rounded-md shadow-lg p-8 flex justify-center items-center w-full h-full bg-cardFieldFocusbg">
              <img
                src={talent}
                alt="AwardgiventoGrandshoprwanda"
                className="object-contain w-full h-full"
              />

              <div>
                <h1 className="font-semibold text-lg">African Talent Award</h1>
                <p className="font-mono">May, 2016</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="flex justify-center items-center shadow-xl">
            <div className="rounded-md shadow-lg p-8 flex justify-center items-center w-full h-full bg-cardFieldFocusbg">
              <img
                src={techAward}
                alt="AwardgiventoGrandshoprwanda"
                className="object-contain w-full h-full"
              />

              <div>
                <h1 className="font-semibold text-lg">TechNovation Award</h1>
                <p className="font-mono">Sep, 20219</p>
              </div>
            </div>
          </SwiperSlide>
        </center>
      </Swiper>
    </>
  );
}
